import camelcase from "camelcase";
import { toQueryString } from "./querystringUtil";
import { snakeCase, toUpper } from "lodash";
import { EXIST } from "e3-common/constants/common";
import { getLocalStorageItem } from "./localStorageUtil";
import { LOCAL_STORAGE_KEYS } from "e3-common/constants/enumerates";

/**
 * controls to payload
 * @param {*} payload
 * @param {*} querystring
 * @returns
 */
export const getValue = (payload, querystring = false, camelCase = false) => {
  let param = {};

  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) {
      return;
    }

    if (key.startsWith("fm") || key.startsWith("fs")) {
      return;
    }

    // if getValue function do not exist, e.g., in a button component, then return
    let value = payload[key]?.ref?.current
      ? payload[key]?.ref?.current?.getValue
        ? payload[key].ref.current?.getValue()
        : ""
      : payload[key];
    if (typeof value === "string") {
      value = value.trim();
    }

    if (key.startsWith("dr")) {
      if (value?.startDate && value?.endDate) {
        if (camelCase) {
          param[camelcase(`${key.replace(/^(dr)/, "")}_start`)] = value.startDate;
          param[camelcase(`${key.replace(/^(dr)/, "")}_end`)] = value.endDate;
        } else {
          param[toUpper(snakeCase(`${key.replace(/^(dr)/, "")}_start`))] = value.startDate;
          param[toUpper(snakeCase(`${key.replace(/^(dr)/, "")}_end`))] = value.endDate;
        }
      }
      return;
    } else if (key.startsWith("rtxt")) {
      if (value?.startValue && value?.endValue) {
        if (camelCase) {
          param[camelcase(`${key.replace(/^(rtxt)/, "")}_start`)] = value.startValue;
          param[camelcase(`${key.replace(/^(rtxt)/, "")}_end`)] = value.endValue;
        } else {
          param[toUpper(snakeCase(`${key.replace(/^(rtxt)/, "")}_start`))] = value.startValue;
          param[toUpper(snakeCase(`${key.replace(/^(rtxt)/, "")}_end`))] = value.endValue;
        }
      } else if (value?.endValue) {
        // 명칭으로 조회가능하게
        if (camelCase) {
          param[camelcase(`${key.replace(/^(rtxt)/, "")}_end`)] = value.endValue;
        } else {
          param[toUpper(snakeCase(`${key.replace(/^(rtxt)/, "")}_end`))] = value.endValue;
        }
      }
      return;
    }

    if (camelCase) {
      param[camelcase(key.replace(/^(mtxt|txt|txa|cbo|cbc|sel|dt|file|chk|gchk|rdo|db|swi|dyl)/, ""))] = value;
    } else {
      param[toUpper(snakeCase(key.replace(/^(mtxt|txt|txa|cbo|cbc|sel|dt|file|chk|gchk|rdo|db|swi|dyl)/, "")))] = value;
    }

    if (payload[key]?.beforeComponents) {
      const subValues = getValue(payload[key]?.beforeComponents, querystring, camelCase);
      Object.assign(param, subValues);
    }
    if (payload[key]?.afterComponents) {
      const subValues = getValue(payload[key]?.afterComponents, querystring, camelCase);
      Object.assign(param, subValues);
    }
  });

  if (querystring) {
    param = toQueryString(param);
  }

  return param;
};

const CONTROL_KEY_PREFIX_REGEX = /^(mtxt|txt|txa|cbo|cbc|sel|dt|file|chk|gchk|rdo|db|swi|dyl)/;

/**
 * ref에 값이 채워지기 전(초기 로드 시)에 controlOption.defaultValue만으로
 * getValue와 동일한 키 규칙의 param 객체를 만든다.
 * @param {object} payload - controls.search 등
 * @param {boolean} [camelCase=false]
 * @returns {object}
 */
export const getDefaultValue = (payload, camelCase = false) => {
  let param = {};

  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) return;
    if (key.startsWith("fm") || key.startsWith("fs")) return;

    const defaultValue = payload[key]?.controlOption?.defaultValue;
    if (defaultValue === undefined) return;

    const value = typeof defaultValue === "string" ? defaultValue.trim() : defaultValue;
    const paramKey = key.replace(CONTROL_KEY_PREFIX_REGEX, "");

    if (camelCase) {
      param[camelcase(paramKey)] = value;
    } else {
      param[toUpper(snakeCase(paramKey))] = value;
    }

    if (payload[key]?.beforeComponents) {
      Object.assign(param, getDefaultValue(payload[key].beforeComponents, camelCase));
    }
    if (payload[key]?.afterComponents) {
      Object.assign(param, getDefaultValue(payload[key].afterComponents, camelCase));
    }
  });

  return param;
};

export const clear = (payload, enabled) => {
  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) return;

    payload[key]?.ref?.current?.clear();
    if (enabled) {
      if (key.startsWith("fm") || key.startsWith("fs") || key.startsWith("gchk")) {
      } else {
        payload[key]?.ref?.current?.enable();
      }
    }
  });
};

export const setReadMode = (payload, b = true) => {
  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) return;

    if (payload[key]?.ref?.current?.setReadOnly) payload[key]?.ref?.current?.setReadOnly(b);
    if (b) {
      if (payload[key]?.ref?.current?.disable) payload[key]?.ref?.current?.disable();
    } else {
      if (payload[key]?.ref?.current?.enable) payload[key]?.ref?.current?.enable();
    }
  });
};

export const changeKeyToCamel = (payload) => {
  let params = [];

  payload.forEach((p) => {
    let param = {};
    Object.keys(p).forEach(function (key) {
      let value = p[key]?.ref?.current ? p[key].ref.current.getValue() : p[key];
      if (key.indexOf("_") > 0) {
        param[camelcase(key)] = value;
      } else {
        param[key] = value;
      }
    });
    params.push(param);
  });

  return params;
};

export const setAllDisable = (payload, disabled) => {
  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) {
      return;
    }

    if (key.startsWith("fm") || key.startsWith("fs")) {
    } else {
      if (disabled) {
        payload[key]?.ref?.current?.disable();
      } else {
        payload[key]?.ref?.current?.enable();
      }
    }
  });
};

/**
 * controls로 만든 컴포넌트가 존재하는지 체크 : ifAuth props을 주면 생성하지 않음
 * @param {*} payload
 * @param {*} key
 * @returns
 */
export const existChk = (control) => {
  if (control === null || control === undefined) {
    return false;
  }

  if (typeof control !== "object") {
    return false;
  }

  const existChkValue = Object.entries(control)
    .map(([key]) => {
      return key === EXIST;
    })
    .filter((x) => x === true).length;

  if (existChkValue > 0) {
    if (!control[EXIST]) return false;
  }

  return true;
};

export const setFindControlLabel = (name, txt) => {
  const inputElement = document.querySelector("#" + name + "label");
  if (inputElement) {
    inputElement.textContent = txt;
  }
};

export const isAuthPermission = async (userId, authId) => {
  const authLists = JSON.parse(getLocalStorageItem(LOCAL_STORAGE_KEYS.AUTH_LISTS));
  const auth = authLists.filter((x) => x.userId.toUpperCase() === userId.toUpperCase() && x.authorityId === authId);
  if (auth.length > 0) {
    return true;
  }
  return false;
};

export const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  console.log(b64Data);
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const hiddenToButtons = (payload, hid = true) => {
  Object.keys(payload).forEach(function (key) {
    if (!existChk(payload[key])) return;

    if (key.startsWith("fm") || key.startsWith("fs") || key.startsWith("gchk")) {
    } else {
      payload[key].button && payload[key]?.button?.ref?.current?.visible(!hid);
    }
  });
};

/**
 * 컨트롤에 자동으로 바인딩
 * @param {Object} payload - The object containing references to controls.
 * @param {Object} data - The data to bind to the controls.
 * @param {number} [type=1] - The depth level of the control to bind (1 or 2).
 */
export const setValuesObj = (payload, data, type = 1) => {
  if (!payload || !data) return;

  if (type === 1) {
    Object.keys(payload).forEach((fieldKey) => {
      const field = payload[fieldKey];
      if (!field || !field.ref || !field.ref.current) return;

      const newKey = fieldKey.replace(/^(cbo|txt|swi|dt|chk|dr)/, "");
      const formattedKey = toUpper(snakeCase(newKey));

      if (fieldKey.startsWith("dr")) {
        if (data.startDate != null && data.endDate != null) {
          if (field.ref.current.setStartDate && field.ref.current.setEndDate) {
            field.ref.current.setStartDate(data.startDate);
            field.ref.current.setEndDate(data.endDate);
          }
        }
      } else if (data[formattedKey] != null && field.ref.current.setValue) {
        field.ref.current.setValue(data[formattedKey]);
      }
    });
  } else if (type === 2) {
    const infos = {};

    Object.keys(payload).forEach((groupName) => {
      const group = payload[groupName];
      infos[groupName] = {};

      if (group) {
        Object.keys(group).forEach((fieldKey) => {
          const newKey = fieldKey.replace(/^(cbo|txt|swi|dt|chk|dr)/, "");
          const formattedKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
          infos[groupName][formattedKey] = group[fieldKey];
        });
      }
    });

    Object.keys(infos).forEach((groupName) => {
      const group = infos[groupName];
      if (!group) return;

      Object.keys(group).forEach((key) => {
        const field = group[key];
        if (!field || !field.ref || !field.ref.current) return;

        if (field.ref.current.setStartDate && field.ref.current.setEndDate) {
          if (data.startDate != null && data.endDate != null) {
            field.ref.current.setStartDate(data.startDate);
            field.ref.current.setEndDate(data.endDate);
          }
        } else if (data[key] != null && field.ref.current.setValue) {
          field.ref.current.setValue(data[key]);
        }
      });
    });
  }
};

// util.js
